export default __webpack_public_path__ + "static/media/Etherfish4.4f0fcad4.gif";